export default __webpack_public_path__ + "static/media/style-belgardBergerac.70fe62da.jpg";